import clsx from "clsx";
import React from "react";
import { Icon } from "../icon/Icon";
import {
  chipCloseButton,
  chipContent,
  chipWrapper,
  clickableChip
} from "./Chip.css";

export interface ChipProps {
  /**
   *  Content to display inside the chip
   */
  children: React.ReactNode;
  /**
   * Optional additional class names
   */
  className?: string;
  /**
   * Whether the chip is disabled
   */
  disabled?: boolean;
  /**
   *  Optional click handler for the chip
   */
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  /**
   * Optional close handler, shows a close icon if provided
   */
  onClose?: () => void;
}

export function Chip({
  children,
  className = "",
  disabled = false,
  onClick,
  onClose
}: ChipProps) {
  const isClickable = !!onClick && !disabled && !onClose;

  return (
    <div
      aria-disabled={disabled}
      role="button"
      className={clsx(chipWrapper, isClickable && clickableChip, className)}
      onClick={disabled ? undefined : onClick}
    >
      <span className={chipContent}>{children}</span>

      {onClose && (
        <div
          role="button"
          aria-disabled={disabled}
          className={chipCloseButton}
          aria-label="Close chip"
          onClick={(event) => {
            if (disabled) return;
            event.stopPropagation();
            onClose();
          }}
        >
          <Icon name="close" />
        </div>
      )}
    </div>
  );
}
